import { GenericTable } from '@components';
import { FC } from 'react';

interface TableProps {
  data: (string | number)[][];
  columns: any[];
}

const Table: FC<TableProps> = ({ data, columns }) => {
  const transformedData = data.map((row: any) =>
    Object.fromEntries(columns.map((col: any, i: any) => [col, row[i]])),
  );

  const transformedColumns = columns.map((col: any) => ({
    key: col,
    label: columns[columns.indexOf(col)],
  }));

  return <GenericTable data={transformedData} columns={transformedColumns} meta={{}} />;
};
export default Table;
